import { translate } from '@bingo/shared';
import { activeLang } from './i18n';

export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message: string,
  ) {
    super(message);
  }
}

/** JSON call to our own API; the session travels in an http-only cookie. */
export async function api<T>(path: string, options: { method?: string; body?: unknown } = {}): Promise<T> {
  let res: Response;
  try {
    res = await fetch(path, {
      method: options.method ?? 'GET',
      credentials: 'same-origin',
      headers: options.body !== undefined ? { 'content-type': 'application/json', 'x-lang': activeLang } : { 'x-lang': activeLang },
      body: options.body !== undefined ? JSON.stringify(options.body) : undefined,
    });
  } catch {
    throw new ApiError(0, 'offline', translate(activeLang, 'No connection to the server. Check the internet and try again.'));
  }
  const data = res.headers.get('content-type')?.includes('json') ? await res.json() : null;
  if (!res.ok) {
    // The owner locked the app: the whole interface switches to the locked screen.
    if (res.status === 423) window.dispatchEvent(new Event('bingo:app-locked'));
    throw new ApiError(res.status, data?.error ?? 'error', data?.message ?? translate(activeLang, 'Request failed ({n}).', { n: res.status }));
  }
  return data as T;
}
